import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { RouterProvider } from "react-router-dom";
import "./App.less";
import { OnlineUsers } from "./helpers/types";
import useOrganizationStructuredData from "./hooks/global/useOrganizationStructuredData";
import { getSuggestionByType, resetSuggestiona } from "./redux/CreatorSuggestion/CreatorSuggestion";
import { filterDiscoversByCreatorId, resetFanDiscovers } from "./redux/discovers/discoversSlice";
import { filterFeedsByCreatorId, resetFeeds } from "./redux/feeds/feedsSlice";
import { clearAllConversations, findAllMessagesByConversationId, getConversationById, setOnlineUsers } from "./redux/messages/messagesSlice";
import { AppDispatch } from "./redux/store";
import { clearOtherUserInfoData } from "./redux/users/usersSlice";
import router from "./routes";
import { authService } from "./services";
import { socket } from "./socket";
import languageUtil from "./utls/LanguageUtil";

if (process.env.NODE_ENV === "production") {
  // Override console methods to no-ops in production!
  console.log = () => {};
  console.warn = () => {};
  // console.error = () => {};
}

function App() {
  const { i18n, t } = useTranslation();

  const tll = new URLSearchParams(window.location.search).get("tll");
  if (tll && authService.isAuthenticated()) {
    sessionStorage.setItem("pendingTrackLink", tll);
  }

  /**
   * todo: remove this block before going to production
   */
  // const [isConnected, setIsConnected] = useState(socket.connected);
  // if (isConnected) {
  //   console.log(`WebSockets connection opened successfully !`);
  // } else {
  //   console.error(`WebSockets connection failed`);
  // }
  /**
   * End
   */

  const dispatch = useDispatch<AppDispatch>();

  useOrganizationStructuredData({ t });

  useEffect(() => {
    const init = async () => {
      const browserLanguage = navigator.language.split("-")[0];
      const supportedLanguages = ["fr", "en", "es"];
      const detectedLanguage = supportedLanguages.includes(browserLanguage) ? browserLanguage : "en";
      const currentLanguage = languageUtil.getPublicCurrentLanguage();
      if (!currentLanguage) {
        await languageUtil.setCurrentLanguage(i18n, detectedLanguage);
      }
    };

    init();
  }, [i18n]);

  useEffect(() => {
    // todo: remove this block before going to production
    // function onConnect() {
    //   setIsConnected(true);
    // }
    // function onDisconnect() {
    //   setIsConnected(false);
    // }
    // End

    function handleUpdateOnlineUsers(data: OnlineUsers) {
      // console.log("online users", data);
      dispatch(setOnlineUsers(data));
    }

    function handleClearCachedData({ creatorId, username, type }: { creatorId: string; username: string; type: string }) {
      dispatch(clearAllConversations());
      dispatch(resetSuggestiona());

      const pathname = window.location.pathname;

      const matchFanInConversation = pathname.match(/\/fan\/requestMedia\/([^/]+)/);
      const matchFanHome = pathname.match(/\/fan\/home/);
      const matchProfile = pathname.match(/^\/p\/([^/]+)$/);
      const matchDiscover = pathname.match(/\/common\/discover/);

      if (matchFanInConversation) {
        const conversationId = matchFanInConversation[1];
        dispatch(getConversationById(conversationId));
        dispatch(findAllMessagesByConversationId({ conversationId, page: 1 }));
      }

      if (matchFanHome && type === "block") {
        dispatch(filterFeedsByCreatorId(creatorId));
        dispatch(getSuggestionByType(4));
      } else {
        dispatch(resetFeeds());
        dispatch(getSuggestionByType(4));
      }

      if (matchDiscover && type === "block") {
        dispatch(filterDiscoversByCreatorId(creatorId));
      } else {
        dispatch(resetFanDiscovers());
      }

      if (matchProfile) {
        if (username === matchProfile[1]) {
          dispatch(clearOtherUserInfoData());
          window.location.reload();
        }
      }
    }

    // socket.on("connect", onConnect);
    // socket.on("disconnect", onDisconnect);

    socket.on("users", handleUpdateOnlineUsers);
    socket.on("clear-cached-data", handleClearCachedData);

    return () => {
      // todo: remove this block before going to production!!
      // socket.off("connect", onConnect);
      // socket.off("disconnect", onDisconnect);
      /**
       * End
       */

      socket.off("users", handleUpdateOnlineUsers);
      socket.off("clear-cached-data", handleClearCachedData);
    };
  }, []);

  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => {
        for (let registration of registrations) {
          registration.unregister();
        }
      })
      .catch((error) => {
        console.error("Service worker unregistration failed: ", error);
      });
  }

  if ("caches" in window) {
    caches.keys().then(function (cacheNames) {
      cacheNames.forEach(function (cacheName) {
        caches.delete(cacheName);
      });
    });
  }

  return (
    <div className="app">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
